import { useEffect } from 'react';
//import 'bootstrap/dist/css/bootstrap.min.css';
//import '../Comunes/Tamanos.css';
import '../Estilos/BienvenidaImpactante.css';
import { useAuth } from '../contextos/AuthProvider'
//import '../Estilos/HomeTareas.css'
import { useNavigate } from 'react-router-dom';



const Home = () => {
    //Rol
    const { Rol, CambiaPerfil, PerfilUsuario, user, Token, ObtenerToken } = useAuth();

    const navigate = useNavigate();
    const Registrar = (ruta) => {
        navigate(ruta);
    }

    const GestionToken = async () => {
        if (!Token) {
            await ObtenerToken();
        }
        if (Token) {
            console.log("Token is available");
        }
        else {
            console.log("Token is not available");
        }

    }

    useEffect(() => {

        GestionToken();
        // eslint-disable-next-line
    }, [])

    if (Rol && Token) {
        return (<>

            <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css"></link>
            <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;600&display=swap" rel="stylesheet"></link>

            <div >
                <div className="containerhome">
                    <header>
                        <h1 style={{ color: '#136633', fontWeight: 'bold', fontSize: '44px' }}>Smart FE</h1>
                        <h2 style={{ color: '#111111' }}>Bienvenido {PerfilUsuario.NombreComercial}</h2>
                    </header>
                    <main>
                        <section className="cardd red">
                            <h3><i className="fas fa-user"></i> Datos</h3>
                            <button style={{ marginBottom: '5px' }} className='btnhome' onClick={() => Registrar('/Clientes/GeneralCliente')}>
                                <i className="fas fa-user-friends"></i> Clientes
                            </button>
                            <button style={{ marginBottom: '5px' }} className='btnhome' onClick={() => Registrar('/Productos/CatalogoGeneral')}>
                                <i className="fas fa-boxes"></i> Catálogo Prod/Serv
                            </button>
                        </section>

                        <section className="cardd blue">
                            <h3><i className="fas fa-edit"></i> Gestión</h3>
                            <button style={{ marginBottom: '5px' }} className='btnhome' onClick={() => Registrar('/Documentos/CrearDocumento')}>
                                <i className="fas fa-file-signature"></i> Crear Documento
                            </button>
                        </section>

                        <section className="cardd green">
                            <h3><i className="fas fa-file-invoice"></i> Documentos</h3>
                            <button style={{ marginBottom: '5px' }} className='btnhome' onClick={() => Registrar('/Documentos/Facturas')}>
                                <i className="fas fa-file-invoice-dollar"></i> Facturas
                            </button>
                            <button style={{ marginBottom: '5px' }} className='btnhome' onClick={() => Registrar('/Documentos/Tiquetes')}>
                                <i className="fas fa-receipt"></i> Tiquetes
                            </button>
                            <button style={{ marginBottom: '5px' }} className='btnhome' onClick={() => Registrar('/Documentos/NCs')}>
                                <i className="fas fa-file-alt"></i> Notas Crédito
                            </button>
                            <button style={{ marginBottom: '5px' }} className='btnhome' onClick={() => Registrar('/Documentos/Compras')}>
                                <i className="fas fa-shopping-cart"></i> Compras
                            </button>
                        </section>

                        <section className="cardd yellow">
                            <h3><i className="fas fa-chart-line"></i> Informes</h3>
                            <button onClick={() => Registrar('/Reporteria/Reportes')} className='btnhome'>
                                <i className="fas fa-chart-bar"></i> Reportes
                            </button>
                            <button onClick={() => Registrar('/Reporteria/Tutoriales')} className='btnhome'>
                                <i className="fas fa-book-open"></i> Tutoriales
                            </button>
                        </section>
                    </main>

                    <footer>
                        <div className="company-select">
                            <label htmlFor="IdCiaActual">Compañía:</label>
                            <select
                                id="IdCiaActual"
                                name="IdCiaActual"
                                className="form-group"
                                onChange={CambiaPerfil}
                                value={PerfilUsuario.IdCia}
                            >
                                {[...Rol]
                                    .sort((a, b) => a.NombreComercial.localeCompare(b.NombreComercial))
                                    .map((option, i) => (
                                        <option key={i} value={option.IdCia}>{option.NombreComercial + ' ' + option.IdCia}</option>
                                    ))
                                }
                            </select>
                            {(user.email === "cristhian@pcservicecr.com") && (
                                <button className="company-btn" onClick={() => Registrar('/Companias/GeneralCia')}>
                                    <i className="fas fa-building"></i> Compañías
                                </button>
                            )}
                        </div>
                    </footer>
                </div>
            </div>
        </>
        );
    } else {
        return <p>Cargando...</p>
    }
}

export default Home;